import type { CmsPage } from "../../types/cms";
import { isSectionHome } from "./pageAddress";
import { pageSectionOf, sectionAllowsHome } from "./pageSection";
import { FRAGMENT_PAGE_TYPE } from "./pageTypeRegistry";

const UNSAFE_SEGMENTS = new Set(["", ".", ".."]);

export function isPreviewablePage(
  page: Pick<CmsPage, "slug" | "section" | "sectionHome" | "type">,
): boolean {
  if (page.type === FRAGMENT_PAGE_TYPE) return false;

  const section = pageSectionOf(page);
  if (isSectionHome(page)) return sectionAllowsHome(section);

  const segments = page.slug.replace(/^\/+/, "").split("/");
  if (segments.some(segment => UNSAFE_SEGMENTS.has(segment))) return false;

  if (section !== "rankings") return true;

  return segments.length === 2 && segments[0] === "launch" && !segments[1].includes("\\");
}
